<template>
  <div class="modal-backdrop">
    <div class="modal" v-click-outside="close">
      <header class="modal-header">
        Are you sure you want to cancel your transaction?
      </header>

      <div class="modal-body">
        <div class="buttons-wrapper">
          <cancel-button
            :is-loading="isCancelling"
            :is-disabled="isCancelling"
            @click="cancelTransaction"
          >
            Cancel Transaction
          </cancel-button>
          <success-button @click="close"> Continue Transaction </success-button>
        </div>
      </div>

      <footer class="modal-footer">
        <div class="title">Having technical difficulties?</div>
        <div>Contact us via:</div>
        <ul>
          <li><span>Our live chat functionality</span></li>
          <li><span>Call us on 011 555 1101</span></li>
          <li><span>Send us an email via support@sidpayment.com</span></li>
        </ul>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { clickOutside } from '@/directives'
import CancelButton from '@/components/buttons/CancelButton'
import SuccessButton from '@/components/buttons/SuccessButton'

export default {
  name: 'CancelTransactionModal',
  components: {
    CancelButton,
    SuccessButton,
  },

  directives: {
    'click-outside': clickOutside,
  },

  props: {
    isShowRetry: {
      type: Boolean,
      default: true,
    },
    isCancelling: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
    }
  },

  computed: {
    ...mapState('appSettings', ['originalUrl']),
  },

  methods: {
    close() {
      this.$emit('close')
    },
    cancelTransaction() {
      this.$emit('cancel-transaction')
      // will be closed automatically because redirected to another page
    },
  },
}
</script>

<style scoped lang="scss">
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 100;
}

.modal {
  background: #fff;
  border-radius: 8px;
  padding: 24px 40px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 480px;
  position: relative;
  top: 10%;

  @media screen and (max-width: $mobile-resolution) {
    width: 90%;
  }
}

.modal-header {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  padding: 0 20px;
}

.modal-footer {
  justify-content: center;
  font-size: 16px;
  line-height: 24px;
  padding: 16px 0 0 0;

  .title {
    font-weight: bold;
  }
  ul {
    margin: 0;
    padding: 0 18px;

    li span {
      position: relative;
      left: -8px;
    }
  }
}

.modal-body {
  position: relative;
  padding: 24px 0;
  border-bottom: 1px solid #d8d8d8;
}

.buttons-wrapper {
  display: flex;
  align-items: center;

  @media screen and (max-width: $mobile-resolution) {
    display: flex;
    flex-direction: column-reverse;
    & .cancel-btn {
      margin: 6px 0 0 0;
      width: 100%;
    }

    & .btn {
      width: 100%;
      margin: 0;
    }
  }
}

.additional-text {
  padding-top: 24px;
  text-align: center;
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
